<template>
  <div class="flex flex-wrap align-div-450">
    <div class="container-img-descirption">
    <!--Product Gallery -->
    <div class="lg:w-4/6 md:w-4/6 align-415-450 flex-type-1">
      <!-- <h2 v-if="product.product_shop" class="text-400 text-3xl font-semibold r">
        {{ product.product_shop.name }}
      </h2> -->
      <!-- <div class="inline">
        <div @click="show">
          <StarRating
            class="float-left"
            :show-rating="false"
            :star-size="25"
            :read-only="true"
            v-model="rating"
          ></StarRating>
          <span class="text-sm text-gray-800 font-semibold my-2"
            >({{ rating }})</span
          >
        </div>
      </div> -->
      <p class="text-gray-500 pt-5 text-400 cat-new-style width-450-display-none" >{{ frontFarbe }} / {{ korpusFarbe }}</p>
      <!--Product Slider -->
      <ProductImageSlider :product="product" class="align-450 "></ProductImageSlider>
      <!--/Product Slider -->
      
      
      <!-- Product Tabs -->
      <!-- <ProductTabsInfo
        :product="product"
        :beschreibung="beschreibung"
        :austtatung="austtatung"
        :lieferInformation="lieferInformation"
        :pdf="pdf"
        :code="code"
        :ratings="ratings"
        :rated="rated"
        :productName="productName"
        @delete-rating="deleteRating"
        @edit-rating="editRating"
        @add-new-rate="addNewRating"
      ></ProductTabsInfo> -->


    </div>
    <div class="lg:w-2/6 md:w-2/6 flex-type-2">
      <div class="pl-5 mt-470">
        <div v-if="product.old_price>0">
          <h2 v-if="product.product_shop" class="text-400  text-new-style mb-2">
        {{ product.product_shop.name }}
      </h2> 
      <div class="flex-resht flex mb-2">
      <div >
          <p class="inline text-sm">Kategorien: </p>
          <span
            v-if="product.product_shop"
            class="font-bold text-teal-400 text-sm"
            >{{ product.product_shop.product.category }}</span
          >
        </div>
        <p style="margin-left: 10px; margin-right: 10px;">.</p>
        <div>
          <p class="inline text-sm">Mehr von: </p>
          <span
            v-if="product.product_shop"
            class="font-bold text-teal-400 text-sm"
            >{{ product.product_shop.shop_name }}</span
          >
        </div>
      </div>
        <hr />

          <h3 class="inline line-through text-xl text-red-500 font-bold qmimi-vjeter">
          {{ product.old_price | formatNumber }}
          </h3>
          <br>
          <h3 class="inline text-3xl  text-teal-400  font-bold qmimi-aktual">
            {{ product.price | formatNumber }}
          </h3>
          <div class="zbritje-new">
         
          <p class="text-red-500 text-zbritjet">Du Sparst: 
            <span class="font-semibold">
              {{ product.old_price - product.price | formatNumber }}
            </span>
          </p>
          <p class="text-red-500 text-zbritjet-perqindja">
            {{ getDiscountPercentage(product.old_price, product.price) }}%
          </p>
        </div>
        </div>
        <div v-else>
          <h3 class="inline \ text-teal-400 font-bold">
          {{ product.price | formatNumber }}
          </h3>
        </div>
        
        
        <p class="mt-4" style="color:grey; font-size: 13px; display: inline;">Menge<span class="line"></span></p>
        

        <div class="pt-2">
          <button
            class="numri-new-plus"
            @click="increment()"
          >
            +
          </button>
          <input
            class="text-center font-bold text-1xl text-teal-400 w-20 numri-new"
            type
            :value="qty"
          />
          <button
            class="numri-new-minus"
            @click="decrement()"
          >
            -
          </button>
        </div>

        <hr class="mt-5 mb-2"/>

        <span class="text-sm">
          <span></span>
          Inkl. MwSt.
        </span>
        <div>
          <p class="inline text-sm text-gray-900" v-if="product.product_shop">
            Lieferzeit:
            <span class="text-teal-400 font-bold">
              <!-- <span v-if="productId == 141"> -->
                <!-- SOFORT LIEFERBAR   -->
              <!-- </span> -->
              <!-- <span v-else> -->
                <!-- added after we commented the else statement -->
                <span>
                <!-- 1-2 Wochen -->
                {{product.product_shop.product.delivery_weeks }}
              </span>
              <!-- Modal -->
              <Modal name="stock-info" width="50%" height="auto">
                <div class="px-4 text-right">
                  <button @click="$modal.hide('stock-info')" class="text-2xl text-teal-400 hover:text-teal-300 font-semibold">
                    <i class="fas fa-times text-2xl"></i>
                  </button>
                  <StockInfoModal/>
                </div>
              </Modal>
              <!-- /Modal -->

              <span class="cursor-pointer hover:text-teal-200" v-if="parseInt(product.product_shop.product.delivery_weeks.substring(0,2)) >= 10">
                <button @click="show" class="inline-block">
                  <i class="text-lg fa fa-info-circle"></i>
                </button>
              </span>
              </span
            >
            <br>
            <span class="text-gray-900 text-xs">
              <span></span> Lieferung bis in die Wohnung
            </span>
          </p>
        </div>
        
      
        <hr class="mt-3" />

        <!-- Lighting -->
        <span v-if="lightId">
           <ProductLighting :lightning="lightning" :lightId="lightId"/><br>
        </span>
        <span v-else>
           <ProductLighting :lightning="lightning"/><br>
        </span>

        <!-- /Lighting -->

        <div class="pt-15 new-style-shto-blej shto-blej-470">

          <router-link to="/checkout">
            <button
              class="bg-teal-400 text-xl text-white rounded  hover:text-teal-400 hover:bg-white new-button-blej"
              @click="addToCart(product)"
            >
              {{ $t("BuyNow") }}
            </button>
          </router-link>

          <button
            class=" text-xl text-white rounded  hover:text-teal-400 hover:bg-white new-button-shto-shporte"
            @click="addToCart(product)"
          >
            {{ $t("AddToCart") }}
          </button>

          
        </div>
     
        <!-- <form class="py-4 cursor-pointer" @click="addWishlist">
          <span
            class="text-white bg-teal-400 px-8 py-2 text-sm rounded hover:bg-white hover:text-teal-400"
          >
            <i class="fa fa-heart hover:text-teal-400"></i>
            Wunschzettel
          </span>
        </form> -->


        <!-- <hr /> -->
        <ProductVariations 
          :farbe="farbe" 
          :dimensions="dimensions"
          :variants="variants"
        ></ProductVariations>
        <!-- <hr /> -->
        <div class="pt-1">
          <div>
            <i class="fas fa-undo text-xs"></i>
            <p class="ml-1 inline text-xs">14 TAGE RÜCKGABERECHT</p>
          </div>
          <div>
            <i class="fas fa-truck text-xs"></i>
            <p class="ml-1 inline text-xs">KOSTENLOSER VERSAND & RÜCKVERSAND</p>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!--/Product Info -->

    <!-- Product Tabs -->
    <ProductTabsInfo
        :product="product"
        :beschreibung="beschreibung"
        :austtatung="austtatung"
        :lieferInformation="lieferInformation"
        :pdf="pdf"
        :code="code"
        :ratings="ratings"
        :rated="rated"
        :productName="productName"
        @delete-rating="deleteRating"
        @edit-rating="editRating"
        @add-new-rate="addNewRating"
      ></ProductTabsInfo>

    <!-- Product Sets -->
    <div class="pt-5 pl-5 padding-450">
      <h3 class="font-semibold text-xl text-gray-900">Diese Serie Shoppen</h3>
      <div class="pt-5 items-center">
        <ProductSet :serie_products="serie_products"
                    :short_name="short_name"></ProductSet>
      </div>
    </div>
    <!-- /Product Sets -->

    <!--Related Product -->
    <div class="pt-5 pl-5 padding-450">
      <h3 class="font-semibold text-xl text-gray-900">
        Das könnte dir auch gefallen
      </h3>
      <div class="pt-5 items-center">
        <ProductSlider :productsByCategory="productsByCategory"></ProductSlider>
      </div>
    </div>
    <!--/Related Product -->

    <!-- Product Ratings -->
    <ProductRatings :ratings="ratings"/>
    <!-- /Product Ratings -->
  </div>
</template>

<script>
import axios from "axios";
import ProductTabsInfo from "./ProductTabInfos";
import ProductImageSlider from "../partials/slider/ProductImageSlider";
import ProductSlider from "../partials/slider/ProductSlider";
import ProductSet from "../partials/slider/ProductSet";
import ProductLighting from "./ProductLightning";
// import StarRating from "vue-star-rating";
import ProductVariations from './ProductVariations'
import StockInfoModal from './StockInfoModal'
import ProductRatings from './ProductRatings';
import mixins from "@/mixins/mixins";


export default {
  props: {
    id: {
      type: Number,
    },
  },
  mixins: [mixins],

  components: {
    ProductTabsInfo,
    ProductImageSlider,
    ProductSlider,
    ProductSet,
    ProductLighting,
    ProductVariations,
    // StarRating,
    StockInfoModal,
    ProductRatings,

  },
  data() {
    return {
      short_name: "",
      product: {},
      productId: this.$route.params.id,
      qty: 1,
      beschreibung: {},
      austtatung: {},
      farbe: [],
      dimensions: [],
      variants: [],
      lieferInformation: [],
      productsByCategory: [],
      serie_products: [],
      pdf: [],
      lightning: [],
      productName: '',
      code: "",
      frontFarbe: "",
      korpusFarbe: "",
      rating: 0,
      ratings: [],
      rated: false,
      error: false,
      lightId: null,
    };
  },
  watch: {
    '$route': function() {
      if(this.$route.hash === "") {
        this.getLightId();
        this.getData();
        location.reload();
      }
    }
  },
  created() {
    console.log(this.productId);
      this.getLightId();
    if(localStorage.getItem('access_token')) {
        this.getAuthData();
      }
      else {
        this.getData();
      }
    if(localStorage.getItem('access_token')) {
      this.getAuthproductsByCategory()
    }
    else {
      this.getproductsByCategory();
    }
    this.getRating();

  },
  methods: {
    getDiscountPercentage(oldPrice, price) {
      const discount = ((oldPrice - price) / oldPrice) * 100;
      // return discount;
      return discount.toFixed(1);
      // return Math.round(discount);
    },
    increment() {
      this.qty++;
    },
    show() {
      this.$modal.show("stock-info");
    },
    hide() {
      this.$modal.hide("stock-info");
    },
    decrement() {
      if (this.qty === 1) {
        this.$notify({
          group: "alert",
          text: "Negative Menge nicht erlaubt!",
        });
      } else {
        this.qty--;
      }
    },
    getproductsByCategory() {
      axios
        .get(`${process.env.VUE_APP_API}/similar-products/${this.productId}`)
        .then((response) => {
          // console.log(response);
          this.productsByCategory = response.data;
        })
        .catch((error) => console.log(error));
    },

    getAuthproductsByCategory() {
      axios
        .get(`${process.env.VUE_APP_API}/asimilar-products/${this.productId}`)
        .then((response) => {
          // console.log(response);
          this.productsByCategory = response.data;
        })
        .catch((error) => console.log(error));
    },

    getLightId() {
      axios
        .get(`${process.env.VUE_APP_API}/getLightId/${this.productId}`)
        .then((response) => {
          this.lightId = response.data[0].id;

        })
        .catch(error => {
          if(error.response.data == 'Nicht Gefunden!'){
            console.log(error.response.data);
            this.$router.push('/*');
          }

        });
    },
    
    getData() {
      axios
        .get(`${process.env.VUE_APP_API}/product/${this.productId}`)
        .then((response) => {
          this.product = response.data.data;
          // console.log(this.product);

          this.pdf = response.data.data.product_shop.product.pdf_file;

          this.code = response.data.data.product_shop.product.code;

          this.beschreibung =
            response.data.data.product_shop.product.attributes.beschreibung;
          
          console.log(this.beschreibung);

          this.austtatung =
            response.data.data.product_shop.product.attributes.ausstatung;

          this.farbe = response.data.data.variants.farbe;

          this.dimensions = response.data.data.variants.dimensions;

          this.variants = response.data.data.variants.variants;

          // console.log(this.farbe);

          // console.log(this.dimensions);

          this.serie_products =
            response.data.data.product_shop.product.serie_products;

            this.short_name = response.data.data.product_shop.product.serie_products[0].productName;

          this.lieferInformation =
            response.data.data.product_shop.product.attributes.beschreibung.Lieferinformation.Lieferumfang;

          this.frontFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Front;

          this.korpusFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Korpus;

          this.lightning = response.data.data.product_shop.product.lightning;

          this.rating = response.data.data.product_shop.product.rating;

          // this.productName = response.data.data.product_shop.product.name;
          this.productName = response.data.data.product_shop.name;

          // console.log('between');
          // console.log(response.data.data.product_shop.product)
          // console.log('between');
        })
        .catch(error => {
          if(error.response.data == 'Nicht Gefunden!'){
            console.log(error.response.data);
            this.$router.push('/*');
          }

        });
    },

    getAuthData() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/aproduct/${this.productId}`)
        .then((response) => {
          this.product = response.data.data;
          // console.log(this.product);

          this.pdf = response.data.data.product_shop.product.pdf_file;

          this.code = response.data.data.product_shop.product.code;

          this.beschreibung =
            response.data.data.product_shop.product.attributes.beschreibung;

          console.log(this.beschreibung);
          
          this.austtatung =
            response.data.data.product_shop.product.attributes.ausstatung;

          this.farbe = response.data.data.variants.farbe;

          this.dimensions = response.data.data.variants.dimensions;

          this.variants = response.data.data.variants.variants;

          // console.log(this.farbe);

          // console.log(this.dimensions);

          this.serie_products =
            response.data.data.product_shop.product.serie_products;

          this.lieferInformation =
            response.data.data.product_shop.product.attributes.beschreibung.Lieferinformation.Lieferumfang;

          this.frontFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Front;

          this.korpusFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Korpus;

          this.lightning = response.data.data.product_shop.product.lightning;

          this.rating = response.data.data.product_shop.product.rating;

          console.log(this.lightning)

          console.log('between');
          this.productName = response.data.data.product_shop.name;
          // LED-Beleuchtung
          console.log()
          console.log('between');
        })
        .catch(error => {
          if(error.response.data == 'Nicht Gefunden!'){
            console.log(error.response.data);
            this.$router.push('/*');
          }

        });
    },

    addWishlist() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: this.product.id,
        button: 'ADD_TO_WISHLIST'
      })

      axios
        .post(`${process.env.VUE_APP_API}/wishlist`, {
          product_id: this.product.id,
        })
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Artikel in den Merkliste gelegt",
            });
          }
        })
        .catch((error) => {
          // console.log(error.response.data.error)
          if(error.response.status === 409) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: error.response.data.error,
            });
          }

          if(error.response.status === 401) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Nicht authentifiziert",
            });
          }
          this.error = true;
        }); 
    },

    getRating() {
      if(localStorage.getItem('access_token')) {
        
        axios.defaults.headers.common["Authorization"] =
         "Bearer " + localStorage.getItem("access_token");
         
         axios.get(`${process.env.VUE_APP_API}/ratings/${this.productId}`)
          .then((response) => {
              this.ratings = response.data.ratings;
              console.log(this.ratings);

              this.rated =  response.data.rated;
              // console.log(this.rated);

          }).catch(error => {
            console.log(error.response.data)
            })
      } else {
        axios.get(`${process.env.VUE_APP_API}/ratings/guest/${this.productId}`)
         .then((response) => {
           this.ratings = response.data.ratings;
           // console.log(this.ratings);
           this.rated =  response.data.rated;

         }).catch(error => {
           console.log(error.response.data)
          })
      }
    },

    addNewRating(rating) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

        axios
          .post(`${process.env.VUE_APP_API}/ratings`, {
            rating
          })
          .then(() => {
            if(!this.error) {
              this.$notify({
                group: "cart",
                title: "Homeface",
                text: "Vielen Danke!",
              })
            }
            
            this.getRating();
          })
          .catch((error) => {
            console.log(error)
              this.$notify({
                group: "cart",
                title: "Homeface",
                text: "Nicht Authentifiziert!",
              })
            this.error = true
          });

    },

    deleteRating(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

        axios.delete(`${process.env.VUE_APP_API}/ratings/${id}`)
        .then(() => {
          this.$notify({
            group: "cart",
            title: "Homeface",
            text: "Vielen Danke!",
          })
          
          this.ratings =  this.ratings.filter(rating => rating.id !== id)
          
          this.getRating();
        }).catch(error => {
          console.log(error)
        })
    },

    editRating(id, rating) {
      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

        axios.put(`${process.env.VUE_APP_API}/ratings/${id}`, {
          rating
        })
        .then(() => {
          
          this.$notify({
            group: "cart",
            title: "Homeface",
            text: "Vielen Danke!",
          })
          this.getRating();
          
        }).catch(error => {
          console.log(error)
        })
    }
  },
};
</script>

<style scoped>
.tooltip .tooltip-text {
  visibility: hidden;
  text-align: center;
  padding: 2px 6px;
  position: absolute;
 
  z-index: 100;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
}


.container-img-descirption{
  width: 100%;
    display: flex;
    flex-direction: row;
    /* border: 1px solid grey; */
    box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.05);
    padding: 10px 30px;
    margin-bottom: 50px;
}

.cat-new-style{
  font-size: 12px;
}

.flex-type-1{
  flex: 1;
  width: 60%;
  margin-top: 30px;
  padding-left: 15px;
}
.flex-type-2{
  flex:3;
  padding-top: 20px;
  padding-bottom:20px;
}

.pt-medium{
  padding-top: 60px;
}

.text-new-style{
  font-family: 500 !important;
  font-size: 16px;
}
.qmimi-vjeter{
  font-size: 14px;
}

.qmimi-aktual{
  font-size: 24px;
}
.zbritje-new{
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.text-zbritjet{
  font-size: 14px;
}
.text-zbritjet-perqindja{
  padding: 1px;
  background-color: rgb(243, 232, 232);
  font-weight: 500;
}
.line {
    display: inline-block;
    border-bottom: 1px solid #e3dfdf;
    width: 400px;
    position: relative;
    top: -2px; /* Adjust this value based on the font size and line height */
    margin-left: 5px;
  }
  .numri-new{
    border: 1px solid rgb(222, 221, 221);
    color: #4c4c4c !important;
    padding: 0 15px;

  }
  .new-style-shto-blej{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
  }
  .numri-new-plus{
    border: 1px solid rgb(222, 221, 221);
    padding: 0 14px;
  }
  .numri-new-minus{
    border: 1px solid rgb(222, 221, 221);
    padding: 0 15px;
  }
  .new-button-shto-shporte, .new-button-blej{
    font-size: 14px;
    padding: 8px 0;
    width: 220px;
  }

  .new-button-shto-shporte{
    color: black;
  }
  .new-button-shto-shporte:hover{
    border: 1px solid rgb(171, 171, 171);
  }

  .new-button-blej:hover{
    background-color: rgb(26, 195, 195);
    color: white;
  }
 


  @media(min-width:415px) and (max-width:450px){
  .align-415-450{
    width:100%;
    padding: 0 !important;

  }
  .padding-450{
    padding-left:0 !important;
  }

  
}

@media(max-width:470px){

.new-button-shto-shporte{
  background-color: #ffffff;

}

.shto-blej-470{
  position: fixed;
    bottom: 0;
    margin-bottom: -3px;
    width: 100%;
    padding: 6px;
    left: 0;
    background-color: #f1f0f0;
    height: 61px;
    z-index: 12333333;
}

  .line{
    width: 250px;
  }

  .qmimi-aktual{
    font-size: 22px;
  }
  .mt-470{
    margin-top: 20px;
    /* transform: translateY(-77px); */
  }

  .flex-type-1{
      -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    padding-right: 20px;
    margin-top: 30px;
    padding-left: 15px;
    }

  .text-400{
    font-size: 14px;
    font-weight: 500;
  }

  .container-img-descirption{
    display: flex;
    flex-direction: column;
  }

  .width-450-display-none{
    display: none;
  }

}

@media(max-width:400px){
  .text-400{
    font-size: 15px;
  }
}

@media(max-width:450px){
  .align-450{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95%;
    padding-left: 14px;
  }
}

@media(min-width:414px) and (max-width:450px){
  .serie-width-450 li{
    width:449px;
  }
}

@media(max-width:450px){
  .align-div-450{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

</style>
